module.exports = __webpack_public_path__ + "img/03.574da3e.png";